<template>
  <div>
    <div align="center">
      <div class="Flex_Table tblEntryForm">
        <div class="Flex_Row">
          <div class="Flex_Cell">
            <div class="Flex_Table" style="width: 100%">
              <div class="Flex_Row" align="center">
                <div class="Flex_Cell HeadFont">
                  <b>ALL PROGRAMMES</b>
                </div>
              </div>
            </div>
            <div
              class="Flex_Table tblEntryForm"
              style="width: 98%; padding: 5px"
              valign="top"
            >
              <div
                class="Flex_Row"
                v-if="ProgList.length > 0"
                style="
                  margin-right: 5px;
                  font-style: 12px;
                  top: 50px;
                  postiion: flex;
                "
              >
                <div
                  id="CoLogoBlock"
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: left;
                    jsutify-content: left;
                  "
                  class="Flex_Cell"
                  v-for="row in ProgList"
                  :key="row.progID"
                  align="left"
                >
                  <div class="Flex_Table tblEntryForm" style="padding: 20px">
                    <div class="Flex_Row">
                      <div class="Flex_Cell" valign="top" style="width: 10%">
                        <img
                          src="../assets/images/80.png"
                          style="height: 40px"
                        />
                      </div>
                      <div class="Flex_Cell" style="width: 90%">
                        <div class="Flex_Cell HeadFont">
                          <span style="display: none">{{ row.progID }}</span>
                          {{ row.progTitle }} ({{ row.progCode }})
                        </div>
                        <div class="Flex_Cell BodyFont">
                          <b>Programme Type : </b> {{ row.progTypeName }}
                        </div>
                        <div class="Flex_Cell BodyFont">
                          <b>Area : </b> {{ row.areaName }}
                        </div>
                        <div class="Flex_Cell BodyFont">
                          <b>Sub Area : </b> {{ row.subAreaName }}
                        </div>
                        <div class="Flex_Cell BodyFont">
                          <b>Duration : </b> {{ row.progDuration }}
                        </div>
                        <div class="Flex_Cell BodyFont">
                          <b>Target Group : </b> {{ row.targetGroup }}
                        </div>
                        <div class="Flex_Cell BodyFont">
                          <b>Programme Mode : </b>
                          {{ row.programmeModeOfExecutionText }}
                        </div>
                        <div class="Flex_Cell BodyFont">
                          <b>Programme Director(s) : </b> {{ row.coordinators }}
                        </div>
                      </div>
                    </div>
                    <div class="Flex_Row">
                      <div
                        class="Flex_Cell"
                        valign="top"
                        style="width: 10%"
                      ></div>
                      <div
                        class="Flex_Cell"
                        style="width: 90%"
                        v-if="row.canApply == 1"
                      >
                        <input
                          type="button"
                          id="btnApply"
                          name="btnApply"
                          btnName="btnApply"
                          value="Apply"
                          style="padding: 10px 40px; margin-left: 10px"
                          title="Click here to Apply"
                          @click="
                            redirectToAppForm(
                              row.progID,
                              row.programmeModeOfExecution,
                              FinYearID,
                              row.progCode
                            )
                          "
                        />
                      </div>
                    </div>
                    <div
                      class="Flex_Row"
                      valign="top"
                      v-if="row.programmeBrochureResp.length > 0"
                    >
                      <div
                        class="Flex_Cell"
                        valign="top"
                        style="width: 10%"
                      ></div>
                      <div
                        class="Flex_Cell"
                        style="width: 90%"
                        v-if="
                          row.programmeBrochureResp.filter((item) => {
                            return item.progID == row.progID;
                          }).length == 1
                        "
                      >
                        <button
                          style="
                            padding: 7px 20px;
                            margin-left: 10px;
                            background-color: #f7b408 !important;
                            color: black !important;
                            cursor: pointer;
                            border-radius: 5px;
                          "
                          type="button"
                          @click="
                            DownloadBrochure(
                              row1.docFileID,
                              'Brochure_' + row.progCode + '.pdf'
                            )
                          "
                          v-for="(
                            row1, index
                          ) in row.programmeBrochureResp.filter((item) => {
                            return item.progID == row.progID;
                          })"
                          :key="index"
                          :id="'btnBrochure'"
                          :title="'Brochure_' + row.progCode + '.pdf'"
                        >
                          <img valign="bottom" src="../assets/images/pdf.png" />
                          <b>Brochure.pdf</b>
                          <!-- <i class="glyphicons download"></i> -->
                        </button>
                      </div>
                      <div
                        class="Flex_Cell"
                        valign="top"
                        style="width: 90%"
                        v-if="
                          row.programmeBrochureResp.filter((item) => {
                            return item.progID == row.progID;
                          }).length > 1
                        "
                      >
                        <button
                          style="
                            padding: 7px 20px;
                            margin-left: 10px;
                            background-color: #f7b408 !important;
                            color: black !important;
                            cursor: pointer;
                            border-radius: 5px;
                          "
                          type="button"
                          @click="
                            DownloadBrochure(
                              row1.docFileID,
                              'Brochure' +
                                (index + 1).toString() +
                                '_' +
                                row.progCode +
                                '.pdf'
                            )
                          "
                          v-for="(
                            row1, index
                          ) in row.programmeBrochureResp.filter((item) => {
                            return item.progID == row.progID;
                          })"
                          :key="index"
                          :id="'btnBrochure'"
                          :title="
                            'Brochure' +
                            (index + 1).toString() +
                            '_' +
                            row.progCode +
                            '.pdf'
                          "
                        >
                          <img valign="bottom" src="../assets/images/pdf.png" />
                          <b>Brochure{{ (index + 1).toString() }}.pdf</b>
                          <!-- <i class="glyphicons download"></i> -->
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="Flex_Row"
                v-else
                style="
                  margin-right: 5px;
                  font-style: 12px;
                  top: 50px;
                  postiion: flex;
                "
              >
                There is no programme
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AllMasterJS from "./serviceJS/AllMasterJS.js";

export default {
  name: "AllProgramme",
  props: {
    ProgList: { required: true },
    UserTypeID: { required: true },
    FinYearID: { required: true },
  },
  components: {},
  data() {
    return {
      prog_list: [],
      progID: -1,
      finMonth_list: [],
      finMonthID: -1,
      finYear_list: [],
      finYearID: -1,
      area_list: [],
      areaID: -1,
      programmeName: "",
    };
  },
  methods: {
    redirectToAppForm(progID, progModeOfExec, finYearID, progCode) {
      this.$root.$data.ProgID = progID;
      this.$root.$data.ProgModeOfExec = progModeOfExec;
      this.$root.$data.FinYearID = finYearID;
      this.$root.$data.ProgCode = progCode;
      this.$router.push({ name: "Application" });
    },
    DownloadBrochure(e) {
      const _data_ = { DocFileID: e, Type: 2 };
      AllMasterJS.DownloadBrochure(_data_).then((response) => {
        var fileExt = response.data[0].docFileExt;
        let imgURL;
        var img = new Image();
        if (fileExt == "pdf") {
          imgURL =
            "data:application/pdf;base64," + response.data[0].docFileContent;
          let dom =
            "<a href='" +
            imgURL +
            "' download>" +
            response.data[0].docFileName +
            "</a>";
          //this.windowPreview.document.write(dom);
          const link = document.createElement("a");
          link.href = imgURL;
          link.download = response.data[0].docFileName;
          link.click();
          URL.revokeObjectURL(link.href);
        } else {
        }
      });
    },
  },
  computed: {},
  watch: {},
  mounted() {
    // console.log(this.ProgList);
    // this.GetProgFinYear();
  },
  //beforeRouteEnter(to, from, next) {},
};
</script>
<style scoped>
/* @import url("../assets/css/Login_v1.0.css"); */
.HeadFont {
  font-size: 13pt;
  color: #161f4e;
}
.BodyFont {
  font-size: 11pt;
  color: #1d1d1d;
}
#CoLogoBlock {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
}
#CoLogoBlock {
  border: solid 1px #0830f714;
  background-color: #0830f714;
  border-radius: 5px;
  margin: 20px;
  padding: 0px;
  max-width: 45%;
  min-width: 25%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}
.instruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 10px;
  border-radius: 5px;
  min-height: 30px;
  line-height: 30px;
  font-size: medium;
  margin-bottom: 6px;
  border-bottom: solid thin darkgrey;
}
.payinstruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 5px;
  border-radius: 5px;
  min-height: 20px;
  line-height: 20px;
  font-size: inherit;
  margin-bottom: 6px;
  /* border-bottom: solid thin darkgrey; */
}
.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  box-shadow: 3px 1px 4px;
  background-color: white;
  color: Black;
}
.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  box-shadow: 3px 1px 4px black;
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.docfileImg {
  height: 50px;
  width: 50px;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  width: 450px;
  border: solid 1px;
  border-radius: 4px;
  top: 200px;
  position: absolute;
  min-height: 256px;
  right: 450px;
  background-color: rgba(255, 248, 248, 0.86); /*rgb(223, 223, 223);*/
  box-shadow: 1px 1px 20px 1px White;
  border-radius: 18px 18px 18px 18px;
  z-index: 2;
  color: black !important;
}
.PopUpDetail {
  padding: 3px;
  min-height: 200px;
  max-height: 400px;
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 30px;
  border-bottom: solid 1px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.drop_area {
  height: 60px;
  background-color: antiquewhite;
  margin: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  line-height: 60px;
}
.file_drop {
  font-size: small;
}
.preview_content {
  background-color: lightblue;
  border-radius: 3px;
  margin: 3px;
  min-height: 177px;
  width: 99%;
  overflow: auto;
  padding: 8px;
  border-radius: 1px 1px 20px 20px;
}
.file_column {
  align-content: center;
  text-align: center;
  float: left;
  width: 25%;
  position: relative;
  /* border: solid thin;
                border-radius: 8px; */
  margin-left: 10px;
}
.file_row:after {
  content: "";
  display: table;
  clear: both;
}
.del_img {
  border-radius: 15px;
  cursor: pointer;
  padding: 5px 5px 5px 5px;
  background-color: rgb(255, 0, 0);
  color: White;
  font-weight: bold;
  position: absolute;
  right: -12px;
  z-index: 5001;
}
.del_img:hover {
  background-color: #fb0bbf;
}
.preview_div {
  align-content: center;
  text-align: center;
  height: 100px;
  width: 110px;
  margin: 2px;
  cursor: pointer;
  border: solid thin darkgray;
  border-radius: 10px;
  background-color: rgba(133, 236, 236, 0.15);
}
.percent_div {
  color: #f3dbdb;
  font-weight: bold;
  align-content: center;
  text-align: center;
  width: 100%;
}
.file_preview {
  height: 80px;
  width: 80px;
}
.file_name {
  font-size: 11px;
  text-overflow: ellipsis;
  width: calc(80%);
  display: inline-block;
  /* color: #f3dbdb; */
}
.file_count {
  margin-top: 5px;
  margin-left: 5px;
  vertical-align: middle;
  padding: 0px 3px 3px 3px;
  font-size: small;
  font-weight: bold;
  font-family: Tahoma;
  background-color: rgba(255, 255, 255, 0.41);
  color: Black;
  border: 1px dashed #ccc;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.error_upload {
  background-color: red;
}
.profileDiv {
  height: 170px;
  width: 180px;
}
.signatureDiv {
  height: 170px;
  width: 300px;
}
.profileImg {
  height: 100%;
  width: 100%;
  border-radius: 10px;
  box-shadow: 5px -4px 5px #807878;
  border-left: solid thin;
  border-bottom: solid thin;
}
.AppHeader {
  border: solid thin gainsboro;
  border-radius: 5px;
  min-height: 55px;
  font-size: medium;
  font-weight: bold;
}
.paymentLabels {
  color: black;
  font-weight: bold;
  font-size: medium;
  text-align: left;
}
.paymentLabels > .Flex_Row {
  border-bottom: solid thin ghostwhite;
}
fieldset {
  margin-bottom: 4px !important;
}
.childSaveTable {
  width: 98%;
  margin-left: 10px;
}
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.Green {
  background-color: greenyellow;
  display: block;
  font-weight: 600;
}
.appNoClass {
  display: inline-block;
  border: solid thin;
  padding: 5px 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  /* font-family: verdana; 
                box-shadow: 1px 1px 4px 2px darkgrey;*/
  margin: 0px !important;
  width: 95%;
}
.appNoClass:hover {
  background-color: darkorange;
}
.hidenShowClass {
  display: inline-block;
  border: solid thin;
  padding: 2px 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  /* font-family: verdana; */
  -webkit-box-shadow: 1px 1px 4px 2px darkgrey;
  box-shadow: 1px 1px 4px 2px darkgrey;
  right: 34px;
  position: absolute;
}
.hidenShowClass:hover {
  background-color: darkorange;
}
.myIconButton {
  padding: 0px;
}
.myIconButton a.glyphicons:before {
  font-size: 21px;
  cursor: pointer;
}
.Multibutton {
  padding: 0px;
}
.Multibutton a.glyphicons:before {
  font-size: 18px;
  cursor: pointer;
  margin-top: -2px;
  display: block;
}
.blackColor {
  color: black;
}
.redColor {
  color: red;
}
.DropDownHeigh {
  height: 27px;
  line-height: 22px;
}
.RowHeight {
  min-height: 29px;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divApplication {
  margin-left: 4px;
  margin-right: 5px;
  border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 0px 5px;
}
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(200px);
  opacity: 0;
}
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
.tblEntryForm > .Flex_Row {
  display: flex;
  flex-wrap: wrap;
}
/* .tblEntryForm > .Flex_Row > .Flex_Cell {
            width: 25% !important;
        } */

@media screen and (max-width: 800px) {
  .HeadFont {
    font-size: 13pt;
  }
  .BodyFont {
    font-size: 11pt;
  }
  #CoLogoBlock {
    width: 700px;
  }
  .imgHeight {
    height: 100%;
  }
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 1023px) {
  .HeadFont {
    font-size: 13pt;
    font-weight: 300;
    color: #161f4e;
  }
  .BodyFont {
    font-size: 11pt;
    color: #1d1d1d;
  }
  #CoLogoBlock,
  #dvPwd {
    width: 380px;
  }
}
@media screen and (max-width: 480px) {
  .HeadFont {
    font-size: 12pt;
  }
  .BodyFont {
    font-size: 9pt;
  }
  #CoLogoBlock {
    width: 700px;
    max-width: 85%;
  }
  .imgHeight {
    height: 90px;
  }
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AllProgramme.vue